      <div class="contact-split"{{{ root }}}>
        <form class="form reveal" data-form novalidate>
          <div class="field">
            <label for="f-name"><span data-i18n="contact.name">Ad Soyad</span> <span class="req" aria-hidden="true">*</span></label>
            <input id="f-name" name="name" type="text" autocomplete="name" required aria-describedby="f-name-err">
            <p class="field-err" id="f-name-err" role="alert" hidden></p>
          </div>

          <div class="field">
            <label for="f-email"><span data-i18n="contact.email">E-posta</span> <span class="req" aria-hidden="true">*</span></label>
            <input id="f-email" name="email" type="email" inputmode="email" autocomplete="email" required
                   aria-describedby="f-email-help f-email-err">
            <p class="field-help" id="f-email-help" data-i18n="contact.emailHelp">Teklifi bu adrese göndeririz.</p>
            <p class="field-err" id="f-email-err" role="alert" hidden></p>
          </div>

          <div class="field">
            <label for="f-type" data-i18n="contact.type">Proje türü</label>
            <select id="f-type" name="type">
              <option value="editorial" data-i18n="contact.type.editorial">Editorial</option>
              <option value="campaign" data-i18n="contact.type.campaign">Kampanya</option>
              <option value="lookbook" data-i18n="contact.type.lookbook">Lookbook</option>
              <option value="video" data-i18n="contact.type.video">Videografi</option>
              <option value="digital" data-i18n="contact.type.digital">Üretken görsel</option>
              <option value="other" data-i18n="contact.type.other">Diğer</option>
            </select>
          </div>

          <div class="field">
            <label for="f-brief"><span data-i18n="contact.brief">Kısa özet</span> <span class="req" aria-hidden="true">*</span></label>
            <textarea id="f-brief" name="brief" rows="5" required aria-describedby="f-brief-help f-brief-err"></textarea>
            <p class="field-help" id="f-brief-help" data-i18n="contact.briefHelp">Tarih aralığı, şehir ve tahmini kare sayısı işimizi kolaylaştırır.</p>
            <p class="field-err" id="f-brief-err" role="alert" hidden></p>
          </div>

          <div class="honeypot" aria-hidden="true">
            <label for="f-website">Web siteniz</label>
            <input id="f-website" name="website" type="text" tabindex="-1" autocomplete="off">
          </div>
{{#if turnstile}}

          <!-- Cloudflare Turnstile: görünmez doğrulama. Çözüm, forma
               `cf-turnstile-response` adlı gizli bir alan olarak yazılır. -->
          <div class="cf-turnstile" data-sitekey="{{ turnstile.siteKey }}" data-appearance="interaction-only" data-language="auto"></div>
{{/if}}

          <button class="btn btn--primary btn--block" type="submit" data-submit>
            <span data-submit-label data-i18n="contact.submit">Gönder</span>
            <svg class="spinner" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/></svg>
          </button>

          <p class="form-status" data-status role="status" aria-live="polite"></p>
        </form>

        <aside class="contact-info reveal">
          <dl>
{{#each info}}
            <dt{{{ label.attrs }}}>{{{ label.html }}}</dt>
            <dd{{{ value.attrs }}}>{{{ value.html }}}</dd>
{{/each}}
          </dl>
{{#if note}}
          <p class="contact-note"{{{ note.attrs }}}>{{{ note.html }}}</p>
{{/if}}
        </aside>
      </div>
